import { ROOT_STORE_NAME } from '../../../store'
import { IStoreState } from '../../../../../reducers/types'
import { commonRedux, CommonReduxTypes } from '../../../../../common/redux'

export const STORE_NAME = '@tilsyn/orgenhet'

const { fetchWithIndexHandlers, fetchActionTypes, fetchActions } =
  commonRedux.fetchWithIndexHelpers<IOrgenhet, typeof STORE_NAME>(
    STORE_NAME,
    'id'
  )

export const orgenhetActionsTypes = fetchActionTypes

export const orgenhetActions = fetchActions

export const orgenhetReducer = {
  [STORE_NAME]: commonRedux.createReducer<IOrgenhetState, IOrgenhetActions>(
    commonRedux.initialListState,
    fetchWithIndexHandlers
  ),
}

// types
export type IOrgenhet = IOrgenhetRemote.Orgenhet

export type IOrgenhetState = CommonReduxTypes.IStateDataList<IOrgenhet>

export type IOrgenhetActions = CommonReduxTypes.IGetActionTypesFromObject<
  typeof orgenhetActions
>

// selectors
export const orgenhetSelectors = {
  dataByMTEnhet: (mtEnhet: string) => (state: IStoreState) =>
    state[ROOT_STORE_NAME][STORE_NAME].data[mtEnhet],
}
